export const StoreInformationModelModule = angular
    .module('app.services.model.models.storeInformationModel', [])
    .value('storeInformationModel', {
        id: 'String',
        name: 'String',
        email: 'String',
        phoneNumber: 'String',
        mailingAddress: {
            address1: 'String',
            address2: 'String',
            city: 'String',
            state: 'String',
            postalCode: 'String',
            country: 'String'
        },
        logo: {
            imageLink: 'any',
            title: 'String',
            description: 'String',
            altText: 'String'
        },
        favicon: {
            imageLink: 'any',
            title: 'String',
            description: 'String',
            altText: 'String'
        },
        dashboardImage: {
            imageLink: 'any',
            title: 'String',
            description: 'String',
            altText: 'String'
        },
        storeUrl: 'String',
        urlHost: 'String',
        socialNetworks: {
            facebook: 'String',
            instagram: 'String',
            twitter: 'String',
            pinterest: 'String',
            google: 'String'
        },
        seo: {
            metaTitle: 'String',
            metaDescription: 'String',
            platformMetaTags: {
                google: 'any',
                bing: 'any',
                pinterest: 'any'
            }
        },
        revision: 'Number',
        stripeEmail: 'String',
        tenant: 'String',
        stripeAccountId: 'String',
        stripePublishableKey: 'String',
        stripeRefreshToken: 'String',
        stripeAccessToken: 'String',
        stripeUserSecretKey: 'String',
        shipsInDays: 'Number',
        shippingFees: 'Boolean',
        chargeTax: ['Boolean', true],
        taxNexus: 'String',
        launched: ['Boolean', false],
        completedLaunchRequirements: ['Boolean', false],
        launchedOn: 'String',
        stripeAccountStatus: 'String',
        acceptCashAsPayment: 'Boolean',
        termsAndConditions: {
            accepted: 'Boolean',
            acceptedBy: 'String',
            acceptedOn: 'String'
        },
        acceptApplePayBuyNowOnProductPages: 'Boolean',
        customAttributes: 'any',
        materialPlan: 'String',
        addedAtLeastOneProduct: 'Boolean',
        emailVerified: 'Boolean',
        stripeCustomerId: 'String',
        customDomain: 'String',
        paypal: {
            isEnabled: ['Boolean', false],
            merchantPayerId: 'String',
            paymentsReceivable: ['Boolean', false],
            permissions: 'Array',
            permissionsGranted: ['Boolean', false],
            prefillActionUrl: 'String',
            primaryEmailConfirmed: ['Boolean', false]
        },
        applePay: {
            isEnabled: ['Boolean', true]
        },
        authorizeNet: {
            accessToken: 'String',
            accessTokenExpiration: 'String',
            accountId: 'String',
            email: 'String',
            isAccountCreated: ['Boolean', false],
            isAccountDenied: ['Boolean', false],
            isEnabled: ['Boolean', false],
            isExistingAccount: ['Boolean', false],
            isPaymentsSignupStarted: ['Boolean', false],
            isPaymentsSignupSubmitted: ['Boolean', false],
            isStripePreferred: ['Boolean', true],
            isTestMode: ['Boolean', false],
            oauthState: 'String',
            refreshToken: 'String',
            refreshTokenExpiration: 'String',
            shouldShowConnectedMessage: ['Boolean', false],
            wasDisconnected: ['Boolean', false]
        },
        wepay: {
            accessToken: 'String',
            accountId: 'String',
            bankAccountLast4: 'String',
            bankAccountId: 'String',
            isConfirmationEmailSent: ['Boolean', false],
            isEnabled: ['Boolean', false],
            isStripePreferred: ['Boolean'],
            kycState: 'String',
            payoutSchedule: 'String',
            payoutType: ['String', 'bankAccount'],
            userState: 'String'
        },
        paymentAutoCapture: ['Boolean', false],
        createdOn: 'String',
        updatedOn: 'String',
        acceptsStripeAsPayment: 'Boolean',
        googleAnalyticsId: 'String',
        thirdPartyIntegrations: {
            adwordsConversionId: 'String',
            adwordsConversionLabel: 'String',
            fullstoryId: 'String',
            facebookTrackingPixelId: 'String',
            addThis: 'String',
            addThisEnabled: 'Boolean',
            privyId: 'String',
            chat: {
                liveChatId: 'String',
                liveChatEmail: 'String'
            },
            googleTagManagerId: 'String'
        },
        enableAddressVerification: 'Boolean'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/storeInformation.model.js